import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TablePagination,
  Stack,
  FormControl,
  Autocomplete,
  TextField,
  Box,
  Typography,
  Grid
} from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import DeleteIcon from '@mui/icons-material/Delete'
import { ApiDeleteAreaManager, ApiGenerateLoginToken, ApiGetAreaManager, ApiGetClientEntityByClientGroupId } from '../../../apiService/Core/Apicall.tsx'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../global/config/store.ts'
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts'
import mmlogo from '../../../assets/images/MM_logo.png'
import aldilogo from '../../../assets/images/Aldi_logo.png'
import bloomslogo from '../../../assets/images/Blooms_logo.png'
import { toast } from 'react-toastify'

const AreaManager: React.FC = () => {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const [searchText, setSearchText] = useState("");
  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
  const [ClientId, setClientId] = useState(null)
  const [clientEntityList, setClientEntityList] = useState<any>([])
  const [clientEntityId, setClientEntityId] = useState<any>(null)
  const dispatch = useDispatch()
  const [AreaManagers, setAreaManagers] = useState([])

  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const adminId: any = localStorage.getItem('userId')


  const fetchAreaManagers = async () => {
    try {
      let data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}&clientGroupName=${selectedClient?.clientGroupName}`
      if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
      if (searchText) data += `&searchTerm=${searchText}`
      const response = await ApiGetAreaManager(data)
      setdatalength(response?.totalCount)
      setAreaManagers(response.data)
    } catch (error) {
      console.error('Error fetching area managers:', error)
    }
  }

  useEffect(() => {
    fetchAreaManagers()
  }, [page, rowsPerPage, selectedClient, searchText, clientEntityId])

  const navigate = useNavigate()

  const addOrUpdateAreaManager = (user?: any) => {
    if (user) {
      navigate(`/admin/add-or-update-areamanager/update/${user.areaId}`, {
        state: { areaManager: user },
      })
    } else {
      navigate('/admin/add-or-update-areamanager/add')
    }
  }
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2])
      setClientId(Clientlist[2].clientGroupName)
    }
  }, [Clientlist])

  useEffect(() => {
    selectedClientName && setSelectedClient(selectedClientName)
  }, [selectedClientName])

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
    if (!selectedClient?.clientGroupName) return
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      setClientEntityList(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }
  useEffect(() => {
    if (selectedClient?.clientGroupName) {
      handleGetClientList()
    }
  }, [selectedClient?.clientGroupName])

  const handleDelete = async (id: any) => {
    try {
      const data = {
        areaId: id
      }
      const res = await ApiDeleteAreaManager(data);
      toast.success(res.message);
      fetchAreaManagers();
    } catch (error: any) {
      console.error("Error Deleting Area Manage.", error)
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message);
    }
  }

  const getClientSiteURL = (hostname: string) => {
    switch (hostname) {
      case "ALDI":
        return process.env.REACT_APP_ALDI_CLIENT_SITE;
      case "BLOOMS":
        return process.env.REACT_APP_BLOOMS_CLIENT_SITE;
      case "MM":
      case "TRANSPORT": // same URL for both
        return process.env.REACT_APP_MM_CLIENT_SITE;
      default:
        return process.env.REACT_APP_MM_CLIENT_SITE;;
    }
  }
  const navigateToLoginShopper = async (user: any) => {

    try {
      const data = {
        adminUserId: adminId,
        targetUserId: user.userId,
        ipAddress: '127.0.0.1',
        browserName: 'Google chrome'

      }
      const res = await ApiGenerateLoginToken(data)
      if (res.success) {
        window.open(`${getClientSiteURL(user.clientGroupName)}?adminuserid=${adminId}&validation=${res.data.token}`, '_blank');
      }
    } catch (error: any) {
      toast.error(error)
    }

  }
  return (
    <div className='w-100 p-2'>
      <Box className='bg-light  border-10 p-2'>
        <Grid container className='p-2 mb-4 mt-3 align-items-center' gap={3}>
          <Grid size={{ xs: 12, md: "auto" }} order={{xs:2,md:1}}>
            <Stack  flexWrap={"wrap"} direction="row" gap={2} >
              <FormControl size="small" sx={{ width: {xs:"100%",md:180} }}>
                <Autocomplete
                  disablePortal
                  id="mm-autocomplete"
                  options={Clientlist}
                  value={selectedClient}
                  getOptionLabel={(option) => option?.clientGroupName}
                  isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                  onChange={(event, newValue: any) => {
                    // setSelectedClient(newValue)
                    dispatch(setSelectedClientGroup(newValue))
                    setClientId(newValue?.clientGroupName || null)
                    // if (
                    //   !newValue ||
                    //   (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)
                    // ) {
                      setClientEntityId(null)
                      setClientEntityList([])
                    // }
                  }}
                  // defaultValue="mmcommon"
                  renderInput={(params) => <TextField {...params} label="Select Client" />}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" sx={{ width: {xs:"100%",md:180} }}>
                <Autocomplete
                  disablePortal
                  id="beacon-autocomplete"
                  options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                  getOptionLabel={(option) => option?.entityName || ""}
                  onChange={(event, newValue: any) => {
                    setClientEntityId(newValue?.clientEntityId || null)
                  }}
                  value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                  renderInput={(params) => <TextField {...params} label="Select Business" />}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" sx={{ width: {xs:"100%",md:300} }}>
                <TextField
                  label="Search"
                  size="small"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </FormControl>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }} order={{xs:1,md:2}}>
            <Typography className='fs-42 text-center'>Area Manager</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: "auto" }} order={{xs:3,md:3}}>
            <Stack>
              <Link
                to={'/admin/add-or-update-areamanager/add'}
                className='table-row-background link-btn'
              >
                Add New Area Manager
              </Link>
            </Stack>
          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
        <Table>
          <TableHead>
            <TableRow className='table-row-background'>
              {["", "", "Entity Name", "Area Manager", "Email", "", ""].map((item) => (<TableCell style={{ color: '#fff' }} >{item}</TableCell>))}
            </TableRow>
          </TableHead>
          <TableBody>
            {AreaManagers.map((user: any) => (
              <TableRow key={user.areaId}>
                <TableCell>
                  <Button variant='contained' className='delete-transparent' onClick={() => handleDelete(user.areaId)}>
                    <DeleteIcon className='delete-icon' />
                  </Button>
                </TableCell>
                <TableCell><Box height={'28px'} component={'img'} src={selectedClient.clientGroupName === "ALDI" ? aldilogo : selectedClient.clientGroupName === "BLOOMS" ? bloomslogo : mmlogo}></Box></TableCell>
                <TableCell>{user.clientEntityName}</TableCell>
                <TableCell>{user.areaName}</TableCell>
                {/* <TableCell>{user.firstName} {user.lastName}</TableCell> */}
                <TableCell>{user.emailId}</TableCell>
                <TableCell>
                  <Link
                  to={`/admin/add-or-update-areamanager/update/${user.areaId}`}
                  className='table-row-background link-btn'
                  >
                    Edit
                  </Link>
                </TableCell>
                <TableCell>
                  <Button
                    variant='contained'
                    onClick={() => navigateToLoginShopper(user)}
                    className='table-row-background'
                  >
                    Login
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </Box>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </div>
  )
}

export default AreaManager
